import { array, object } from "yup";

import { dbIdValidationSchema } from "@dzambalaorg/yup-rules";

export const validationSchema = object().shape({
  merchantIds: array()
    .of(dbIdValidationSchema)
    .required("form.validations.valueMissing")
    .min(1, "form.validations.arrayMinLength"),
});
